import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import { t } from "../../lib/i18n";
import { type Role, type UserSelectOption, usersApi } from "../../lib/api/users";

import "./ui.css";

interface UserSelectProps {
  value: string;
  onChange: (id: string, option: UserSelectOption | null) => void;
  role?: Role;
  placeholder?: string;
  id?: string;
  required?: boolean;
}

export function UserSelect({
  value,
  onChange,
  role,
  placeholder,
  id,
  required,
}: UserSelectProps) {
  const [search, setSearch] = useState("");

  const options = useQuery({
    queryKey: ["user-select-options", role ?? "any", search],
    queryFn: () => usersApi.selectOptions({ role, search: search || undefined }),
  });

  return (
    <div className="user-select">
      <input
        className="input"
        type="search"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder={placeholder ?? t("users.selectPlaceholder")}
      />
      <select
        id={id}
        className="input select"
        value={value}
        onChange={(e) => {
          const id = e.target.value;
          const opt = options.data?.find((o) => o.id === id) ?? null;
          onChange(id, opt);
        }}
        required={required}
      >
        <option value="">{t("common.select")}</option>
        {(options.data ?? []).map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
